module.exports = __webpack_public_path__ + "static/media/netflix.a1f673e7.png";